<template>
  <div>
    <div class="integral" v-for="p in list" :key="p.id">
      <div class="left"><img :src="p.image_url"></img></div>
      <div class="right">
        <div class="title">{{p.activity_name}}</div>
        <div class="description">{{p.info}}</div>
        <div class="action">
          <div class="input-number"><span>兑换数量 </span><el-input-number size="small" v-model="num" :min="1" :max="max"></el-input-number></div>
          <div class="btn" v-if="p.status == 0" @click="exchange(p)">申请兑换</div>
          <div class="btn" v-else style="background: #D8DCE5;">已过期</div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { API__code, API_Integral } from '../../api/index.js'
export default {
  props:['usable'],
  data(){
    return{
      num:1,
      list:[],
      token:'',
      checkCode:'',
      max:1
    }
  },
  created(){
    
    this.getCookie();
    this.getList()
  },
  watch:{
    'usable':function(){
      this.max = parseInt(this.usable/2000) || 1;
    }
  },
  methods:{
    exchange(item){
      
      this.$confirm('确认申请兑换吗?', '提示', {
        type: 'warning'
      }).then(() => {
        var params = {
          token:this.token,
          checkCode:this.checkCode,
          userId:sessionStorage.getItem('dnnypt_id'),
          id:item.id,
          count:this.num
        }
        this.$emit('exchange',2);
        API_Integral.exchange(params)
				  .then((res)=>{
          if(res.data.code == API__code.SUCCESS){
            this.$emit('exchange',1);
            this.$message.success('申请成功');
          }else if(res.data.code == '201'){
            this.$emit('exchange',3);
            this.$message.warning('积分不足');
          }
        })
      })
      
    },
    getList(){
      var params = {
        token:this.token,
        checkCode:this.checkCode,
      }
      API_Integral.getList(params)
				.then((res)=>{
          if(res.data.code == API__code.SUCCESS){
            this.list = res.data.data;
          }
        })
    },
		//读取cookie
		getCookie: function() {
		  if (document.cookie.length > 0) {
				var arr = document.cookie.split('; ');
				for (var i = 0; i < arr.length; i++) {
						var arr2 = arr[i].split('=');
						if (arr2[0] == 'dnnypt_token') {
								this.token = arr2[1];
						} else if (arr2[0] == 'dnnypt_checkCode') {
								this.checkCode = arr2[1];
						}
				}
			}
	  }
  },
};
</script>
<style lang="scss" scoped>
.integral {
  width: 100%;
  height: 160px;
  background: #ffffff;
  border-radius: 12px;
  display: flex;
  margin-bottom: 12px;
  

  .left {
    flex: 0 0 160px;
    padding: 20px;
    box-sizing: border-box;
    img {
      width: 100%;
      height: 100%;
    }
  }
  .right {
    width: 100%;
    flex: 0 0 calc(100%-160px);
    padding: 20px 20px 20px 0px;
    box-sizing: border-box;
    .title {
      font-family: Noto Sans SC;
      font-style: normal;
      font-weight: 500;
      font-size: 20px;
      line-height: 30px;
      color: #333333;
    }

    .description{
      width: 100%;
      font-family: Noto Sans SC;
      font-style: normal;
      font-weight: normal;
      font-size: 14px;
      height: 44px;
      line-height: 22px;
      color: #999999;
      //white-space: nowrap;
			overflow: hidden;
      display: -webkit-box;
      text-overflow: ellipsis;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
    }

    .action{
      margin-top: 15px;
      width: 100%;
      display: flex;

      .input-number{
        flex:0 0 72%;
        

        span{
          color: #666666;
          font-size: 14px;
          position: relative;
          top: 1px;
          margin-right: 15px;
        }
      }

      .btn{
        flex:0 0 28%;
        width: 144px;
        height: 33px;
        line-height: 33px;
        text-align: center;
        background: #F66B3D;
        border-radius: 2px;
        color: white;
        cursor: pointer;
      }
    }
  }
}

// @media only screen and (max-width:1380px ) {
//  .right{
//   flex:0 0 66% !important;
//  }

//  .left{
//   flex:0 0 34% !important;
//  }
// }
</style>




// WEBPACK FOOTER //
// exchange.vue?7d03951a